<div class="card my-3 full-height-card" *ngIf="title">
	<div class="flex justify-content-between">
		<h5 class="font-bold">{{ title }}</h5>
		<ng-container *ngIf="!hideButton">
			<p-button
				[label]="buttonLabel"
				(onClick)="buttonClick.emit()"
				[icon]="'pi ' + buttonIcon"
				[loading]="buttonLoading"
				[disabled]="buttonDisabled"
				[text]="true"
				[iconPos]="'left'"
				[style]="{ 'cursor': buttonDisabled ? 'not-allowed' : 'pointer' }"
			/>
		</ng-container>
	</div>

	<div class="variable-grid-container">
		<div
			*ngFor="let row of rows; trackBy: trackByRowFields"
			class="grid-row"
			[style.grid-template-columns]="'repeat(' + maxColumns + ', 1fr)'"
		>
			<!-- 1 field = 1 column, so we can calculate emptyCount based on fields.length  -->
			<div *ngFor="let field of row.fields" class="field-item">
				<p class="font-bold">{{ labels[field].text || field }}</p>
				<small class="field-help-text" *ngIf="fieldHelpTexts[field]">{{ fieldHelpTexts[field] }}</small>
				<div class="field-value-row">
					<span class="field-value">
						<ng-container *ngIf="labels[field]?.pipe; else plainValue">
							{{ info[field] | dynamicPipe: labels[field].pipe || '' }}
						</ng-container>
						<ng-template #plainValue>{{ displayValue(info[field]) }}</ng-template>
					</span>
					<ng-container *ngIf="fieldBadges[field] as badge">
						<p-tag
							[value]="badge.value"
							[severity]="badge.severity"
							[styleClass]="badge.styleClass || ''"
							class="ml-2"
						/>
					</ng-container>
					<ng-container *ngIf="fieldActions[field]?.visible">
						<p-button
							[label]="fieldActions[field].label"
							[icon]="fieldActions[field].icon ? 'pi ' + fieldActions[field].icon : undefined"
							[severity]="fieldActions[field].severity || 'danger'"
							[loading]="!!fieldActions[field].loading"
							[text]="true"
							[iconPos]="'left'"
							styleClass="p-button-sm field-inline-action"
							(onClick)="fieldActionClick.emit(field)"
						/>
					</ng-container>
				</div>
				<div class="field-subvalue-row" *ngIf="fieldSubvalues[field]">
					<span class="field-subvalue">{{ fieldSubvalues[field] }}</span>
					<button
						*ngIf="fieldSubvalueCopyable[field]"
						type="button"
						class="field-subvalue-copy"
						[title]="copiedField === field ? 'Copied' : 'Copy to clipboard'"
						(click)="copySubvalue(field)"
					>
						<i class="pi" [ngClass]="copiedField === field ? 'pi-check' : 'pi-copy'"></i>
					</button>
				</div>
			</div>
			<!-- empty divs for alignment when row has fewer fields than maxColumns -->
			<div *ngFor="let i of getEmptySlots(row)" class="field-item empty-slot"></div>
		</div>
	</div>
</div>
